import { tv } from "@fanka/tailwind-variants";
import clsx from "clsx";

export const SWITCH_ROOT_CLASS_NAME = tv({
  base: clsx(
    "box-border w-full h-8 rounded-[4px] border px-4 py-1 font-bold flex justify-center items-center gap-1 text-ui12 data-[state=unchecked]:text-ui-300 group",
    // hover
    "hover:bg-ui-300 hover:border-ui-300",
    // icon
    "[&_svg]:data-[state=unchecked]:fill-ui-300",
  ),
  variants: {
    iconType: {
      left: "pl-2 pr-4",
      right: "pr-2 pl-4",
      only: "",
    },
    theme: {
      light: clsx(
        // on
        "data-[state=checked]:text-ui-500",
        // hover
        "data-[state=checked]:hover:text-ui-white data-[state=unchecked]:hover:text-ui-white",
        // icon
        "[&_svg]:data-[state=checked]:fill-ui-400 [&_svg]:fill-ui-100",
      ),
      dark: clsx(
        // on
        "data-[state=checked]:text-ui-white",
        // hover
        "data-[state=checked]:hover:text-ui-400 data-[state=unchecked]:hover:text-ui-400",
        // icon
        "[&_svg]:data-[state=checked]:fill-ui-white ",
      ),
    },
  },
  defaultVariants: {
    theme: "light",
  },
});

export const SWITCH_THUMB_CLASS_NAME = tv({
  base: "flex items-center justify-center gap-1",
  variants: {
    theme: {
      light: "group-hover:[&_svg]:fill-ui-100",
      dark: "group-hover:[&_svg]:fill-ui-400",
    },
  },
  defaultVariants: {
    theme: "light",
  },
});
